import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    paddingTop: 5,
    paddingBottom: 5,
    minWidth: '50%',
  },
});
